import CreditCardIcon from "@mui/icons-material/CreditCard";
import ListIbans from "./List";
import { IBANS, PaymentServicePath } from "utils/constants";
import EditIBans from "./Edit";
import CreateIbans from "./Create";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <CreditCardIcon />,
  name: PaymentServicePath + IBANS,
  title: "IBANS",
  list: <ListIbans />,
  create: <CreateIbans />,
  createPermission: permissions.canCreateIbanDetails,
  edit: <EditIBans />,
  editPermission: permissions.canUpdateIbanDetails,
  permission: permissions.canPreviewIbanDetails,
};
